import { render, staticRenderFns } from "./SearchEmpMg.vue?vue&type=template&id=36b33e5c&scoped=true"
import script from "./SearchEmpMg.vue?vue&type=script&lang=js"
export * from "./SearchEmpMg.vue?vue&type=script&lang=js"
import style0 from "./SearchEmpMg.vue?vue&type=style&index=0&id=36b33e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b33e5c",
  null
  
)

export default component.exports